import React from 'react';
import Button from './Button';

export default function FinalCTACard({
  title,
  titleEm,
  description,
  ctaText = 'Κράτηση Online',
  ctaHref = '#',
  ctaTarget,
  ctaRel,
  className = '',
}) {
  return (
    <div className={`
      relative max-w-container-narrow mx-auto rounded-card-xl
      bg-warm-black
      text-cream p-[60px_30px] md:p-[90px_60px] 
      overflow-hidden text-center
      ${className}
    `}>
      {/* Subtle gold glow */}
      <div 
        className="absolute -top-[120px] left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none opacity-30"
        style={{ background: 'radial-gradient(ellipse, rgba(201,162,39,0.35), transparent 65%)' }}
      />

      {/* Star accent top */}
      <div className="absolute top-9 left-1/2 -translate-x-1/2 text-[32px] text-gold-light opacity-40">
        ✦
      </div>
      
      <h2 className="font-serif text-display-l leading-[0.95] font-medium tracking-[-2px] mb-[22px] relative z-10">
        {title}
        {titleEm && (
          <>
            <br />
            <em className="italic text-gold-light">{titleEm}</em>
          </>
        )}
      </h2>
      
      {description && (
        <p className="text-[18px] text-cream/75 mb-10 max-w-[580px] mx-auto relative z-10">
          {description}
        </p>
      )}
      
      <Button 
        variant="gold"
        href={ctaHref}
        target={ctaTarget}
        rel={ctaRel}
      >
        {ctaText} <span>→</span>
      </Button>
    </div>
  );
}